<input
  #inputImage
  (change)="imageFromHtmlElement(inputImage)"
  [disabled]="uploadDisabled()"
  (touch)="onTouch()"
  [accept]="acceptAttribute()"
  type="file"
  name="photo"
  style="display: none"
/>

<ng-content />
